// Global JS

(function nerivioGlobal($, Drupal) {
  Drupal.behaviors.accessibilityChanges = {
    attach(context) {
      /* Add tabindex attribute to H tags if not present. */
      $('h1, h2, h3, h4, h5, h6', context).each(function() {
        if (!$(this).attr('tabindex')) {
          $(this).attr('tabindex', 0);
        }
      });

      // Custom modal - JS
      // Open modal when anchor link is clicked
      $(".country-selector__region").click(function(e) {
        e.preventDefault();
        $(".custom-modal, .custom-modal + .custom-ui-widget-overlay").css("display", "block");
      });

      // Close the modal when close button is clicked
      $(".custom-ui-dialog-titlebar-close, .country-selector-card__cta").click(function() {
        $(".custom-modal, .custom-modal + .custom-ui-widget-overlay").css("display", "none");
        $(".lang-selector-dropdown-wrap, .lang-selector-dropdown-wrap + .custom-ui-widget-overlay").css("display", "none");
        $(".lang-selector-dropdown-wrap").removeClass("lang-selector-dropdown-open").attr('style', '');
      });

      // Close the modal when clicking outside the modal content
      const $menu = $('.custom-modal'); // This is a selector on which click we dont wont to close.
      $(document).mouseup(e => {
        if (!$menu.is(e.target)
        && $menu.has(e.target).length === 0) {
          $(".custom-modal, .custom-modal + .custom-ui-widget-overlay").css("display", "none");
          $(".lang-selector-dropdown-wrap, .lang-selector-dropdown-wrap + .custom-ui-widget-overlay").css("display", "none");
          $(".lang-selector-dropdown-wrap").removeClass("lang-selector-dropdown-open").attr('style', '');
        }
      });

      if ($(window).width() < 1280) {
        // Open modal when anchor link is clicked
        $("#shortLanguageCode .lang-code").click(function(e) {
          e.preventDefault();
          $(".lang-selector-dropdown-wrap, .lang-selector-dropdown-wrap + .custom-ui-widget-overlay").css("display", "block");
          $(".lang-selector-dropdown-wrap").addClass("lang-selector-dropdown-open");
        });

        // Close the modal when clicking outside the modal content
        $(".lang-selector-dropdown-wrap + .custom-ui-widget-overlay").on('click', function(e) {
          e.stopImmediatePropagation();
          $(".lang-selector-dropdown-wrap, .lang-selector-dropdown-wrap + .custom-ui-widget-overlay").css("display", "none");
          $(".lang-selector-dropdown-wrap").removeClass("lang-selector-dropdown-open");
        });
      }
    },
  };

  Drupal.behaviors.trainingVideoCard = {
    attach(context) {
      once("training-video-initialized", "body", context).forEach(() => {

        // Function to replace the registered symbol within specified elements
        function replaceRegisteredSymbol(elements) {
          elements.forEach(function(element) {
            element.innerHTML = element.innerHTML.replace(/®/g, '<span class="superscript">®</span>');
          });
        }

        // Handle teaser box content
        const teaserBoxContent = document.querySelector('.teaser-videobox_content');
        if (teaserBoxContent) {
          const elements = teaserBoxContent.querySelectorAll('h2, p');
          replaceRegisteredSymbol(elements);
        }

        // Handle training videos content
        const trainingVideosContent = document.querySelector('.view-training-videos');
        if (trainingVideosContent) {
          const cardListingBlock = trainingVideosContent.querySelector('.card-listing-block');
          if (cardListingBlock) {
            const cardListingBlockItems = cardListingBlock.querySelectorAll('.video-card-text');
            cardListingBlockItems.forEach(function(item) {
              const cardTitleLinks = item.querySelectorAll('a');
              replaceRegisteredSymbol(cardTitleLinks);
            });
          }
        }
        const links = context.querySelectorAll('.image-card-carousel-wrapper.image-card-carousel.large-card-carousel .video-card-block a');
        links.forEach(link => {
          link.innerHTML = link.innerHTML.replace(/®/g, '<span class="superscript">®</span>');
        });

      });
    },
  };
})(jQuery, Drupal);

//scrolling issue fix
window.addEventListener("load", function () {
  const hash = window.location.hash;

  if (hash) {
    setTimeout(() => {
      const target = document.querySelector(hash);
      if (target) {
        let offset = 0;

        if (window.innerWidth <= 390) {
          offset = 150;
        } else if (window.innerWidth <= 768) {
          offset = 180;
        } else {
          offset = 120;
        }

        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY - offset,
          behavior: "smooth"
        });
      }
    }, 100);
  }
});

let scrollEventsTriggered = new Set();
function handleScroll() {
  const scrollTop = window.scrollY;
  const docHeight = document.documentElement.scrollHeight - window.innerHeight;
  const scrollPercent = Math.round((scrollTop / docHeight) * 100);
  const thresholds = [10, 25, 50, 75, 100];

  thresholds.forEach(threshold => {
    if (scrollPercent >= threshold && !scrollEventsTriggered.has(threshold)) {
      dataLayer.push({
        event: "page_scroll",
        scroll_percentage: `${threshold}%`
      });
      scrollEventsTriggered.add(threshold);
    }
  });
}
window.addEventListener("scroll", handleScroll);
function handleLogoClick(event) {
  dataLayer.push({
    event: "logo_click"
  });
}
const logoLink = document.querySelector('.logo-link');
if (logoLink) {
  logoLink.addEventListener('click', handleLogoClick);
}

const menuLinks = document.querySelectorAll('.nlevel-menu-default-wrapper.mr-8.li-level-0.li-menu.haschild');
function handlemenuClick(event) {
  const menuLink = event.currentTarget;
  const category1 = menuLink.querySelector('a')?.textContent.trim() || '';
  const clickedElement = event.target.closest('a');
  const category2 = clickedElement ? clickedElement.textContent.trim() : '';
  dataLayer.push({
    event: "category_menu",
    category_1: category1,
    category_2: category2
  });

  if (clickedElement && clickedElement.getAttribute('href') === "/es-en/womens-health" || clickedElement && clickedElement.getAttribute('href') === "/es-es/la-salud-de-las-mujeres") {
    dataLayer.push({
      event: "women_health",
      page: "Category menu"
    });
  }
  if (clickedElement && clickedElement.getAttribute('href') === "/es-en/tracking-migraine-phases" || clickedElement && clickedElement.getAttribute('href') === "/es-es/seguimiento-de-las-fases-de-la-migrana") {
    dataLayer.push({
      event: "track_migrane_phases",
      page: "Category menu"
    });
  }
  if (clickedElement && clickedElement.getAttribute('href') === "/es-en/teenagers-parents" || clickedElement && clickedElement.getAttribute('href') === "/es-es/adolescentes-y-padres") {
    dataLayer.push({
      event: "teenagers_and_parents",
      page: "Category menu"
    });
  }


}
menuLinks.forEach(menuLink => {
  menuLink.addEventListener('click', handlemenuClick);
});

const shopifyLinks = document.querySelectorAll('a[href*="https://es-shop.nerivio.eu/products/nerivio"]');
const shopifyenLinks = document.querySelectorAll('a[href*="https://es-shop.nerivio.eu/en/products/nerivio"]');
function handleShopifyClick(event) {
  let pageClicked = '';
  const isInHeader = event.currentTarget.closest('.header-nerivio.primary-header') !== null;
  if(isInHeader) {
    pageClicked = "Category Menu"
  }
  else {
    pageClicked = "Homepage"
  }
  dataLayer.push({
    event: "get_nerivio",
    page: pageClicked
  });
}
shopifyLinks.forEach(link => {
  link.addEventListener("click", handleShopifyClick);
});
shopifyenLinks.forEach(link => {
  link.addEventListener("click", handleShopifyClick);
});

const textMediaTags = document.querySelectorAll('.text-media a');
textMediaTags.forEach(textTag => {
  textTag.addEventListener('click', handleMediaTextCtaClick);
});

function handleMediaTextCtaClick(event) {
  if (event.currentTarget.classList.contains('nerivio_functions')) {
    dataLayer.push({
      event: "nerivio_functions"
    });
  }
  if (event.currentTarget.classList.contains('scientific_facts')) {
    dataLayer.push({
      event: "scientific_facts",
      page: "Nerivio Functions Page"
    });
  }

  if (event.currentTarget.classList.contains('migrane_resources_steps')) {
    linkClicked = event.currentTarget.textContent.trim();
    dataLayer.push({
      event: "migrane_resources_steps",
      selected_step: linkClicked
    });
  }

  if (event.currentTarget.classList.contains('expert_circles_steps')) {
    linkClicked = event.currentTarget.textContent.trim();
    dataLayer.push({
      event: "expert_circles_steps",
      selected_step: linkClicked
    });
  }

  if (event.currentTarget.classList.contains('women_health_steps')) {
    linkClicked = event.currentTarget.textContent.trim();
    dataLayer.push({
      event: "women_health_steps",
      selected_step: linkClicked
    });
  }

  if (event.currentTarget.classList.contains('studies_steps')) {
    linkClicked = event.currentTarget.textContent.trim();
    dataLayer.push({
      event: "studies_steps",
      selected_step: linkClicked
    });
  }

  if (event.currentTarget.classList.contains('print_studies_pdf')) {
    dataLayer.push({
      event: "print_studies_pdf",
    });
  }

  if (event.currentTarget.classList.contains('track_migrane_phases_steps')) {
    linkClicked = event.currentTarget.textContent.trim();
    dataLayer.push({
      event: "track_migrane_phases_steps",
      selected_step: linkClicked
    });
  }

  if (event.currentTarget.classList.contains('teenagers_and_parents_steps')) {
    linkClicked = event.currentTarget.textContent.trim();
    dataLayer.push({
      event: "teenagers_and_parents_steps",
      selected_step: linkClicked
    });
  }

  if (event.currentTarget.classList.contains('prodrome_steps')) {
    linkClicked = event.currentTarget.textContent.trim();
    dataLayer.push({
      event: "prodrome_steps",
      selected_step: linkClicked
    });
  }

  if (event.currentTarget.classList.contains('aura_steps')) {
    linkClicked = event.currentTarget.textContent.trim();
    dataLayer.push({
      event: "aura_steps",
      selected_step: linkClicked
    });
  }

  if (event.currentTarget.classList.contains('postdrome_steps')) {
    linkClicked = event.currentTarget.textContent.trim();
    dataLayer.push({
      event: "postdrome_steps",
      selected_step: linkClicked
    });
  }

  if (event.currentTarget.classList.contains('headache_steps')) {
    linkClicked = event.currentTarget.textContent.trim();
    dataLayer.push({
      event: "headache_steps",
      selected_step: linkClicked
    });
  }

  if (event.currentTarget.classList.contains('prodrome_click')) {
    dataLayer.push({
      event: "prodrome_click",
      page: "Migrane Resources page"
    });
  }
  if (event.currentTarget.classList.contains('aura_click')) {
    dataLayer.push({
      event: "aura_click",
      page: "Migrane Resources page"
    });
  }
  if (event.currentTarget.classList.contains('headache_click')) {
    dataLayer.push({
      event: "headache_click",
      page: "Migrane Resources page"
    });
  }
  if (event.currentTarget.classList.contains('postdrome_click')) {
    dataLayer.push({
      event: "postdrome_click",
      page: "Migrane Resources page"
    });
  }

  if (window.location.pathname === "/es-en/migraine-resources" || window.location.pathname === "/es-es/migrana-recursos") {
    if (event.currentTarget.classList.contains('women_health')) {
      dataLayer.push({
        event: "women_health",
        page: "Migrane Resources page"
      });
    }
    if (event.currentTarget.classList.contains('track_migrane_phases')) {
      dataLayer.push({
        event: "track_migrane_phases",
        page: "Migrane Resources page"
      });
    }
    if (event.currentTarget.classList.contains('teenagers_and_parents')) {
      dataLayer.push({
        event: "teenagers_and_parents",
        page: "Migrane Resources page"
      });
    }
  }
}

const textTags = document.querySelectorAll('.text_block a');
textTags.forEach(textTag => {
  textTag.addEventListener('click', handleTextCtaClick);
});

function handleTextCtaClick(event) {
  if (event.currentTarget.classList.contains('scientific_facts')) {
    dataLayer.push({
      event: "scientific_facts",
      page: "Homepage"
    });
  }
  if (event.currentTarget.classList.contains('sources_click')) {
    linkClicked = event.currentTarget.textContent.trim();
    dataLayer.push({
      event: "sources_click",
      selected_option: linkClicked,
      page: "Women's Health"
    });
  }
  if (event.currentTarget.classList.contains('postpartum_click')) {
    linkClicked = event.currentTarget.textContent.trim();
    dataLayer.push({
      event: "postpartum_click",
      page: "Women's health page"
    });
  }
  if (event.currentTarget.classList.contains('read_article')) {
    const parentDiv = event.currentTarget.closest('.text_block');
    const h2Text = parentDiv ? parentDiv.querySelector('h2')?.textContent.trim() : '';
    dataLayer.push({
      event: "read_article",
      article_selected: h2Text
    });
  }
  if (event.currentTarget.classList.contains('nerivio_user_manual')) {
    dataLayer.push({
      event: "nerivio_user_manual"
    });
  }
  if (event.currentTarget.classList.contains('check_eligibility')) {
    dataLayer.push({
      event: "check_eligibility"
    });
  }
}

function handleFooterClick(event) {
  const buttonClicked = event.currentTarget.textContent.trim();
  dataLayer.push({
    event: "footer_click",
    button_clicked: buttonClicked
  });
}
const footerLinks = document.querySelectorAll('.menu__horizontal--item.menu__item-level-0 a');
footerLinks.forEach(footerLink => {
  footerLink.addEventListener('click', handleFooterClick);
});

document.addEventListener("DOMContentLoaded", function() {
  let pageName = '';
  if (window.location.pathname === "/es-en/how-it-works" || window.location.pathname === "/es-es/como-funciona") {
    pageName = "nerivio_functions_page";
  }
  if (window.location.pathname === "/es-en/teenagers-parents" || window.location.pathname === "/es-es/adolescentes-y-padres") {
    pageName = "teenagers_and_parents_page";
  }
  if (window.location.pathname === "/es-en/migraine-resources" || window.location.pathname === "/es-es/migrana-recursos") {
    pageName = "migrane_resources_page";
  }
  if (window.location.pathname === "/es-en/womens-health" || window.location.pathname === "/es-es/la-salud-de-las-mujeres") {
    pageName = "women_health_page";
  }
  if (window.location.pathname === "/es-en/tracking-migraine-phases" || window.location.pathname === "/es-es/seguimiento-de-las-fases-de-la-migrana") {
    pageName = "track_migrane_phases_page";
  }

  if (window.location.pathname === "/es-en/prodrome" || window.location.pathname === "/es-es/prodromo") {
    pageName = "prodrome_page";
  }
  if (window.location.pathname === "/es-en/aura" || window.location.pathname === "/es-es/aura") {
    pageName = "aura_page";
  }
  if (window.location.pathname === "/es-en/postdrome" || window.location.pathname === "/es-es/postdromo") {
    pageName = "postdrome_page";
  }
  if (window.location.pathname === "/es-en/postpartum" || window.location.pathname === "/es-es/posparto") {
    pageName = "postpartum_page";
  }
  if (window.location.pathname === "/es-en/faqs" || window.location.pathname === "/es-es/preguntas-frecuentes") {
    pageName = "nerivio_faq_page";
  }
  if (window.location.pathname === "/es-en/experts-overview" || window.location.pathname === "/es-es/circulos-de-expertos") {
    pageName = "expert_circles_page";
  }
  if (window.location.pathname === "/es-en/studies" || window.location.pathname === "/es-es/estudios") {
    pageName = "studies_page";
  }
  if (window.location.pathname === "/es-en/contact-us-hcp" || window.location.pathname === "/es-es/contacto-para-profesionales-sanitarios") {
    pageName = "hcp_contact_us_page";
  }
  if (window.location.pathname === "/es-en/training-videos" || window.location.pathname === "/es-es/training-videos-spanish") {
    pageName = "training_videos_page";
  }
  if (window.location.pathname === "/es-en/attack" || window.location.pathname === "/es-es/ataque") {
    pageName = "headache_page";
  }
  if (window.location.pathname === "/es-en/nerivio-teens" || window.location.pathname === "/es-es/para-adolescentes") {
    pageName = "manage_teen_migranes_page";
  }
  if(pageName) {
    dataLayer.push({
      event: pageName
    });
  }

  if (window.location.pathname === "/es-en/contact-us-patient" || window.location.pathname === "/es-es/contactenos-paciente") {
    dataLayer.push({
      event: "patient_contact_us_page",
      page: "Health Personnel"
     });
  }

  const observer = new MutationObserver(function (mutationsList) {
    mutationsList.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.matches && node.matches('.webform-confirmation-modal')) {
          const form_patient = document.querySelector('.webform-submission-contact-form-node-376-form');
          if (form_patient) {
            dataLayer.push({
              event: "patient_contact_us_submit",
              page: "Health Personnel",
            });
          }
          const form_hcp = document.querySelector('.webform-submission-contact-webform-node-441-form');
          if (form_hcp) {
            dataLayer.push({
              event: "hcp_contact_us_submit"
            });
          }
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
});

const accordionLinks = document.querySelectorAll('.accordion-item a');
accordionLinks.forEach(accordionLink => {
  accordionLink.addEventListener('click', handleAccordionLink);
});
function handleAccordionLink(event) {
  const accordionLink = event.currentTarget;
  const h4Element = accordionLink.querySelector('h4');
  let linkClicked = h4Element ? h4Element.textContent.trim() : '';
  dataLayer.push({
    event: "nerivio_faq_selected",
    selected_question: linkClicked
  });
}

const fileLinks = document.querySelectorAll('.download-file .file a');
fileLinks.forEach(fileLink => {
  fileLink.addEventListener('click', handleFileLink);
});

function handleFileLink(event) {
  const buttonClicked = event.currentTarget.textContent.trim();
  const buttonUrl = event.currentTarget.getAttribute("href");
  dataLayer.push({
    event: "download_material",
    selected_material: buttonClicked
  });
}

const videoCards = document.querySelectorAll('.video-card-block');
videoCards.forEach(videoCard => {
  videoCard.addEventListener('click', handleVideo);
});

function handleVideo(event) {
  const videoTitle = event.currentTarget.querySelector('.video__card--title').textContent.trim();
  dataLayer.push({
    event: "training_video_selected",
    selected_video: videoTitle
  });
}

const authorCards = document.querySelectorAll('.author-container .author-container__cta a');
authorCards.forEach(authorCard => {
  authorCard.addEventListener('click', handleAuthorCard);
});

function handleAuthorCard(event) {
  if (event.currentTarget.classList.contains('download_summary')) {
    dataLayer.push({
      event: "download_summary"
    });
  }
}

const langLists = document.querySelectorAll('.lang-list .lang-list__item a');
langLists.forEach(langList => {
  langList.addEventListener('click', handleLangList);
});
function handleLangList(event) {
  linkClicked = event.currentTarget.textContent.trim();
  dataLayer.push({
    event: "change_language",
    language: linkClicked
   });
}

const regionLists = document.querySelectorAll('.country-selector-card__item a');
regionLists.forEach(regionList => {
  regionList.addEventListener('click', handleRegionList);
});

function handleRegionList(event) {
  const region = event.currentTarget.closest('.country-selector-card__item');
  const regionName = region.querySelector('.country-selector-card__name').textContent.trim();
  dataLayer.push({
    event: "change_country",
    country: regionName,
    region: "Europe"
  });
}

(function(Drupal) {
  Drupal.behaviors.webformConfirmationModalFix = {
    attach: function(context) {
      if (context !== document) {
        return;
      }

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && node.classList.contains('ui-dialog')) {
              if (node.querySelector('.webform-confirmation-modal--content')) {
                node.classList.add('webform-confirmation-modal');
              }
            }
          });
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  };
})(Drupal);
